// draggableNode.js
import { NodeIcons } from './nodes/nodeIcons';

export const DraggableNode = ({ type, label }) => {
  const Icon = NodeIcons[type] || NodeIcons['default'];

  const onDragStart = (event, nodeType) => {
    const appData = { nodeType }
    event.target.style.cursor = 'grabbing';
    event.dataTransfer.setData('application/reactflow', JSON.stringify(appData));
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      className="
        cursor-grab px-3 py-2 flex items-center gap-2 rounded-md 
        hover:bg-indigo-50 hover:text-indigo-600 hover:ring-1 hover:ring-indigo-200 
        transition-all text-gray-600 text-sm font-medium select-none
      "
      onDragStart={(event) => onDragStart(event, type)}
      onDragEnd={(event) => (event.target.style.cursor = 'grab')}
      draggable
    >
      <Icon className="w-4 h-4" />
      <span>{label}</span>
      {/* Ghost Clone for dragging visual could be improved but browser default is okay for now */}
    </div>
  );
};
